const MockData = [
  {
    code: 'G0000699',
    stock: {
      stockLevel: 1,
      stockLevelStatus: 'lowStock'
    }
  },
  {
    code: 'G0000799',
    stock: {
      stockLevel: 0,
      stockLevelStatus: 'outOfStock'
    }
  },
  {
    code: 'G0000601',
    stock: {
      stockLevel: 1,
      stockLevelStatus: 'lowStock'
    }
  },
  {
    code: 'G0000602',
    stock: {
      stockLevel: 0,
      stockLevelStatus: 'outOfStock'
    }
  },
  {
    code: 'G0000604',
    stock: {
      stockLevel: 0,
      stockLevelStatus: 'outOfStock'
    }
  }
]

export default MockData
